export const services = [
  {
    id: 'electronics-recycling',
    title: 'Electronics Recycling',
    icon: 'ri-computer-line',
    shortDesc: 'Certified recycling for computers, monitors, TVs, and all electronics.',
    fullDesc: 'We accept all types of consumer and commercial electronics for responsible recycling. Our certified process ensures zero landfill waste for computers, monitors, televisions, printers, and peripherals. We provide certificates of recycling for businesses.',
    image: '/images/Electronics-Recycling.jpg',
    items: ['Desktop Computers', 'Laptops & Tablets', 'Monitors & TVs', 'Printers & Fax', 'Keyboards & Mice', 'Network Equipment'],
  },
  {
    id: 'hard-drive-shredding',
    title: 'Hard Drive Shredding',
    icon: 'ri-hard-drive-line',
    shortDesc: 'On-site and off-site hard drive destruction with certificate of destruction.',
    fullDesc: 'Protect your sensitive business data with our industrial hard drive shredding service. We physically destroy each drive and provide a serialized certificate of destruction. NIST 800-88 compliant, ideal for HIPAA, SOX, and GLBA compliance.',
    image: '/images/Hard-Drive-Shredding.jpg',
    items: ['HDD & SSD Drives', 'USB Drives & Memory Cards', 'Backup Tapes', 'Cell Phones', 'Certificate of Destruction', 'NIST 800-88 Compliant'],
  },
  {
    id: 'data-destruction',
    title: 'Guaranteed Data Destruction',
    icon: 'ri-shield-check-line',
    shortDesc: 'Software-based data wiping with DOD 5220.22-M standard certification.',
    fullDesc: 'Our multi-pass data overwrite service meets the DoD 5220.22-M standard, ensuring every byte is permanently unrecoverable. Perfect for businesses that need to reuse or resell equipment while maintaining compliance. Each device receives a signed destruction certificate.',
    image: '/images/Guaranteed Data Destruction.jpg',
    items: ['DoD 5220.22-M Standard', 'Multi-Pass Overwriting', 'Detailed Reporting', 'Compliance Documentation', 'Asset Tracking', 'Bulk Processing'],
  },
  {
    id: 'cell-phone-destruction',
    title: 'Cell Phone Destruction',
    icon: 'ri-smartphone-line',
    shortDesc: 'Complete physical destruction of mobile devices to protect your data.',
    fullDesc: 'Mobile devices carry enormous amounts of personal and corporate data. Our cell phone destruction service physically shreds your devices beyond any recovery. We handle all makes and models including smartphones, tablets, and feature phones.',
    image: '/images/cell-phone-destruction.jpg',
    items: ['All Smartphone Models', 'Tablets & iPads', 'Feature Phones', 'GPS Devices', 'Smartwatches', 'Physical Shredding'],
  },
  {
    id: 'ewaste-pickup',
    title: 'E-Waste Pickup',
    icon: 'ri-truck-line',
    shortDesc: 'Free scheduled e-waste pickup for businesses in Los Angeles County.',
    fullDesc: 'We offer complimentary e-waste pickup for qualifying businesses throughout Los Angeles County and surrounding areas. Our uniformed technicians arrive on-time, handle all loading, and provide same-day documentation. Serving LA, Orange County, and the Inland Empire.',
    image: 'images/ewaste-pickup.jpg',
    items: ['Los Angeles County', 'Orange County', 'Inland Empire', 'Same-Day Documentation', 'No Minimum Quantity', 'Business & Residential'],
  },
  {
    id: 'tape-product-destruction',
    title: 'Tape & Product Destruction',
    icon: 'ri-film-line',
    shortDesc: 'Destruction of backup tapes, optical media, and branded products.',
    fullDesc: 'We destroy backup tapes (LTO, DLT, DAT), optical media (CDs/DVDs/Blu-ray), and branded/proprietary products that require secure disposal. Our shredding is verified and certified, protecting your intellectual property and sensitive stored data.',
    image: '/images/tape-product-destruction.jpg',
    items: ['LTO, DLT, DAT Tapes', 'CDs, DVDs, Blu-ray', 'X-ray Films', 'Branded Products', 'Proprietary Materials', 'Certificate Included'],
  },
];

export const serviceStats = [
  { value: '15+', label: 'Years in Business' },
  { value: '50K+', label: 'Devices Recycled Monthly' },
  { value: '100%', label: 'Certified & Compliant' },
  { value: '500+', label: 'Business Clients' },
];
